import { FormikHelpers } from 'formik';

import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { Cluster } from 'pages/complementar/cluster/types';

export function useMutateCluster() {
    const { setContent } = useFormContext();
    const { mutate } = useFormMutation<{ data: { data: Cluster } }>();

    /**
     * Método responsável por enviar os dados do formulário para a API.
     */
    const handleSubmit = (formData: Cluster, formik: FormikHelpers<Cluster>) => {
        mutate(
            {
                formik,
                formData,
                url: '/gestao/clusterloja',
                idField: 'idClusterLoja',
            },
            {
                onSuccess: ({ data }) => {
                    if (data?.data) setContent(data.data);
                },
            },
        );
    };

    return { handleSubmit };
}
